












import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class UmbPortalRedirect extends Vue {
  @Prop() action: string;

  @Prop() token: string;

  formId = "redirectSSOForm";

  mounted () {
    document.forms[this.formId].submit();
  }
}
